/* assets/src/viewer/core/controls.js
 * OrbitControls da three/addons (port :1516-1542).
 */
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export function createControls(camera, domElement, handlers = {}) {
  const controls = new OrbitControls(camera, domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.06;
  controls.screenSpacePanning = false;
  controls.maxPolarAngle = Math.PI / 2 - 0.04;
  controls.minPolarAngle = 0.5;
  controls.minDistance = 2;
  controls.maxDistance = 20;
  controls.enablePan = false;
  controls.autoRotate = false;
  controls.autoRotateSpeed = 0.65;
  controls.target.set(0, 1.7, 0);
  controls.update();

  const { onChange, onStart, onEnd, onInteract } = handlers;
  if (onChange) controls.addEventListener('change', onChange);
  if (onStart) controls.addEventListener('start', onStart);
  if (onEnd) controls.addEventListener('end', onEnd);
  if (onInteract) {
    ['pointerdown', 'wheel', 'touchstart'].forEach((evt) => {
      domElement.addEventListener(evt, onInteract, { passive: true });
    });
  }
  return controls;
}
